/* global $ */
import { core } from '@/core'

const SwitchUtil = {
  group(opt, tar) {
    const { name, valid } = opt
    const group = $(`
    <div role="switch" class="lt-switch" aria-checked="true">
      <input type="hidden" name="${name}">
      <input type="checkbox" true-value="true" class="switch__input">
      <span class="switch__label switch__lab-left is-active">
        <span aria-hidden="true"></span>
      </span>
      <span class="switch__core" style="width: 40px;"></span>
      <span class="switch__label switch__lab-right">
        <span></span>
      </span>
    </div>`)
    const input = group.find('input[type="checkbox"]')
    const hidden = group.find('input[type="hidden"]')
    const left = group.find('.switch__lab-left')
    const right = group.find('.switch__lab-right')
    const leftSpan = left.find('span')
    const rightSpan = right.find('span')
    Object.assign(tar, { group, input, hidden, item: { left, right, leftSpan, rightSpan } })
    const button = group.children()
    button.click($.proxy(tar.handleClick, tar))
  },
  unit (opt, tar) {
    this.group(opt, tar)
    tar.unit = tar.group
    core.update(this.updater, opt, tar)
    tar.hidden.val(tar.value)
  },
  updater: {
    value (value, opt, tar, node) {
      if ($.type(value) === 'boolean') {
        const { unit, input, item: { left, right, leftSpan, rightSpan } } = tar
        input.prop('checked', value)
        if (value) {
          unit.addClass('is-checked')
          left.removeClass('is-active')
          right.addClass('is-active')
          leftSpan.removeAttr('aria-hidden', 'true')
          rightSpan.attr('aria-hidden', 'true')
        } else {
          unit.removeClass('is-checked')
          left.addClass('is-active')
          right.removeClass('is-active')
          leftSpan.attr('aria-hidden', 'true')
          rightSpan.removeAttr('aria-hidden', 'true')
        }
      } else if ($.type(value) === 'array') {
        const index = tar.data.findIndex(x => x === value)
        let key = false
        if (index === 1) key = true
        SwitchUtil.updater.value(key, opt, tar, node)
      }
    },
    disabled (value, opt, tar, node) {
      const { unit, input } = tar
      input.prop('disabled', value)
      if (value) {
        unit.addClass('is-disabled').attr('aria-disabled', true)
      } else {
        unit.removeClass('is-disabled').removeAttr('aria-disabled')
      }
    },
    data (value, opt, tar, node) {
      if (value && value.length >= 2) {
        const { item: { leftSpan, rightSpan } } = tar
        leftSpan.text(value[0].text)
        rightSpan.text(value[1].text)
      }
    }
  }
}

export default class Switch {
  constructor(opt) {
    this.defaults = {
      name: '', // 原生属性: name
      disabled: true, // 是否禁用
      data: [
        { id: '0', text: '按年付费' },
        { id: '1', text: '按月付费' }
      ], // 数据
      value: false, // 是否选中
      dataValue: [] // [{id,text},{id,text},...] 格式的数据
    }
    this.item = {} // 储存组件局部信息
    core.proxyApi(this) // 核心属性处理
    this.settings = Object.assign({}, this.defaults, opt)
    this.init()
  }

  init () {
    SwitchUtil.unit(this.settings, this)
  }

  handleClick (data, e) {
    this.value = !this.value
  }

  update (fn) {
    this._update = fn
  }
}
